import { render, staticRenderFns } from "./Contains.vue?vue&type=template&id=16e64de3&scoped=true"
import script from "./Contains.vue?vue&type=script&lang=js"
export * from "./Contains.vue?vue&type=script&lang=js"
import style0 from "./Contains.vue?vue&type=style&index=0&id=16e64de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e64de3",
  null
  
)

export default component.exports